import React, { useState, useRef, useEffect } from "react";
import { DateRange } from "react-date-range";
import { FaSearch, FaCalendarAlt } from "react-icons/fa";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const FiltersBar = ({
  search,
  setSearch,
  hallFilter,
  setHallFilter,
  statusFilter,
  setStatusFilter,
  dateRange,
  setDateRange,
  halls
}) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [tempRange, setTempRange] = useState([]);

  const calendarRef = useRef(null);

  useEffect(() => {
    console.log("halls 👉", halls);
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const { startDate, endDate } = dateRange[0];

  return (
    <div className="bg-white shadow-xl rounded-2xl p-6 mb-8 relative">
      {/* Header */}
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-gray-700">
          Search & Filters
        </h3>
      </div>

      {/* Filters Grid */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 items-end">
        {/* Search */}
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-600 mb-1">
            Search by 
          </label>
          <div className="relative">
            <FaSearch className="absolute left-3 top-3 text-gray-400" />
            <input
              type="text"
              placeholder="Enter Id/Name"
              className="pl-10 pr-4 py-2 border rounded-xl w-full focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        {/* Hall Filter */}
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-600 mb-1">
            Venue
          </label>
          <select
  value={hallFilter}
  onChange={(e) => setHallFilter(e.target.value)}
  className="px-4 py-2 border rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
>
  <option value="">All Halls</option>

  {halls?.map((h) => (
  <option key={h.Id} value={h.Id}>
    {h.Name}
  </option>
))}
</select>
        </div>

        {/* Status */}
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-600 mb-1">
            Booking Status
          </label>
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="px-4 py-2 border rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
          >
            <option value="">All Status</option>
            <option value="Upcoming">Upcoming</option>
            <option value="Completed">Completed</option>
            <option value="Cancelled">Cancelled</option>
          </select>
        </div>

        {/* Date Range */}
        <div className="flex flex-col relative">
          <label className="text-sm font-medium text-gray-600 mb-1">
            Event Date Range
          </label>

          <button
            onClick={() => {
              setTempRange(
                dateRange[0].startDate
                  ? dateRange
                  : [
                      {
                        startDate: new Date(),
                        endDate: new Date(),
                        key: "selection",
                      },
                    ],
              );
              setShowCalendar(!showCalendar);
            }}
            className="flex items-center gap-2 px-4 py-2 border rounded-xl text-left focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
          >
            <FaCalendarAlt className="text-gray-400" />
            {startDate && endDate
              ? `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
              : "Select date range"}
          </button>

          {showCalendar && (
            <div
              ref={calendarRef}
              className="absolute right-0 top-[calc(100%+8px)] z-50 bg-white shadow-2xl rounded-xl p-4"
            >
              <DateRange
                editableDateInputs
                moveRangeOnFirstSelection={false}
                ranges={tempRange[0].startDate ? tempRange : []}
                onChange={(item) => setTempRange([item.selection])}
                rangeColors={["#10b981"]}
              />

              <div className="flex justify-between mt-3">
                {/* Default Button */}
                <button
                  onClick={() => {
                    setTempRange([
                      {
                        startDate: null,
                        endDate: null,
                        key: "selection",
                      },
                    ]);
                    setDateRange([
                      {
                        startDate: null,
                        endDate: null,
                        key: "selection",
                      },
                    ]);
                    setShowCalendar(false);
                  }}
                  className="px-3 py-1 text-sm border rounded-lg"
                >
                  Default
                </button>

                <div className="flex gap-2">
                  <button
                    onClick={() => setShowCalendar(false)}
                    className="px-3 py-1 text-sm border rounded-lg"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={() => {
                      setDateRange(tempRange);
                      setShowCalendar(false);
                    }}
                    className="px-3 py-1 text-sm bg-emerald-500 text-white rounded-lg"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FiltersBar;
